import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "./slices/counter";
import { djangoApi } from "./slices/djangoApi";
import powerCycleReducer from "./slices/powerCycleSlice";
import firmwareUpdateReducer from "./slices/firmwareUpdateSlice";

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    [djangoApi.reducerPath]: djangoApi.reducer,
    powerCycle: powerCycleReducer,
    firmwareUpdate: firmwareUpdateReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(djangoApi.middleware),
});
